import { Events, EventBus } from '@/lib/events'
import { createKeywordsArrayFromSession } from '@/lib/helpers/common'

export const state = () => ({
  wordmark: '',
  slogan: '',
  keywords: '',
  keywordedPhrases: null,
  industry: { id: '', name: '' },
})

export const actions = {
  async sendSessionToKeyworder({ state, commit }) {
    const keywords = createKeywordsArrayFromSession(state)
    try {
      const response = await this.$api.get(process.env.KEYWORD_API, {
        params: { phrases: keywords },
      })
      if (!response.error) {
        commit('setKeywordedPhrases', response.data.phrases)
        return response
      }
      commit('setKeywordedPhrases', [])
      return []
    } catch (error) {
      commit('setKeywordedPhrases', [])
    }
  },
}

export const mutations = {
  setKeywordedPhrases(state, phrases) {
    state.keywordedPhrases = phrases
  },

  setWordmark(state, wordmark) {
    if (state.wordmark !== wordmark) {
      EventBus.$emit(Events.AppWordmarkUpdated, wordmark)
    }

    state.wordmark = wordmark
  },

  setSlogan(state, input) {
    const slogan = typeof input === 'string' ? input.trim() : input

    if (state.slogan !== slogan) {
      EventBus.$emit(Events.AppSloganUpdated, slogan)
    }

    state.slogan = slogan
  },

  setKeywords(state, keywords) {
    state.keywords = (keywords || '').replace(/[^a-zA-Z0-9 ]/g, '')
  },

  setIndustry(state, industry) {
    state.industry = industry
  },

  reset(state) {
    state.wordmark = ''
    state.keywords = ''
    state.slogan = ''
    state.keywordedPhrases = null
    state.industry = null
  },
}

export const getters = {
  // get 3 keywords.
  // First use wordmark words, then slogan words,
  // then whatever else is available
  getKeywordsForFlow({ keywordedPhrases, wordmark, slogan }) {
    if (!keywordedPhrases) return []

    const wordmarkPhrase = keywordedPhrases.find(
      phrase => phrase.phrase === wordmark
    )

    const sloganPhrase = keywordedPhrases.find(
      phrase => phrase.phrase === slogan
    )

    const otherPhrases = keywordedPhrases.filter(
      phrase => phrase.phrase !== slogan && phrase.phrase !== wordmark
    )

    const phrases = []
    if (wordmarkPhrase) {
      phrases.push(wordmarkPhrase)
    }
    if (sloganPhrase) {
      phrases.push(sloganPhrase)
    }

    if (otherPhrases.length > 0) {
      phrases.push(...otherPhrases)
    }

    const result = []
    phrases.forEach(phrase => {
      phrase.words.forEach(word => {
        result.push(word.word)
      })
    })

    return [...new Set([...result])].filter(Boolean).slice(0, 3)
  },

  getKeywords({ keywords = '', keywordedPhrases }) {
    const input = keywords ? keywords.toLowerCase().split(' ') : []
    const phrases = keywordedPhrases || []
    let matched = []

    // Grab nested keywords
    if (phrases.length > 0) {
      phrases.forEach(phrase => {
        phrase.words.forEach(word => {
          matched.push(word.word)
        })
      })

      matched = matched.reverse()
    }

    // Combine keywords with user input, filter dupes, and grab the first 10
    //  items in-case field validation hasn't run
    return [...new Set([...matched, ...input])].filter(Boolean).slice(0, 10)
  },
}
